import { darken, styled } from '@mui/material/styles'
import { Button } from '@mui/material'
import { createWithLoadingButton } from '$common/buttons/with-loading-button'

// TODO it should be clear for color of button on hover
const StyledButton = styled(Button)(({ theme }) => ({
  border: `1px solid ${theme.palette.secondary500}`,
  backgroundColor: theme.palette.neutral000,
  color: theme.palette.secondary500,
  '&:hover': {
    backgroundColor: darken(theme.palette.neutral000, 0.2),
  },
  '&.Mui-disabled': {
    backgroundColor: `${theme.palette.neutral000} !important`,
    color: theme.palette.secondary300,
    borderColor: theme.palette.secondary300,
  },
  '& .MuiButton-endIcon': {
    margin: 0,
    '& > svg': {
      fontSize: '24px',
    },
  },
}))

export const SecondaryOutlinedButton = createWithLoadingButton(StyledButton)
